import React, { useEffect, useState } from "react";
import { usePhrase } from "@/contexts/LanguageContext";
import { api } from "@/lib/api";
import { Route } from "lucide-react";
import { DisclaimerBanner } from "@/components/DisclaimerBanner";

const routeDetails = {
  "Regular bank term loan": { desc: "Traditional bank term loan against business appraisal & security.", tenure: "3-7 years" },
  "Working-capital facility": { desc: "Cash credit / OD to fund operations, receivables & inventory.", tenure: "Renewable" },
  "CGTMSE-indicated route": { desc: "Guarantee cover applied to collateral-free credit up to ₹5 Cr.", tenure: "Per lender" },
  "Equipment finance": { desc: "Hypothecation-based machinery/equipment loan.", tenure: "3-7 years" },
  "MP State scheme route": { desc: "MP MSME / Yuva / Udyam Kranti / Startup 2025 policy support.", tenure: "Per scheme" },
  "Stand-Up India / Women enterprise route": { desc: "Loan ₹10L-1Cr for greenfield SC/ST/Women promoters.", tenure: "Up to 7 years" },
  "Improve-first route": { desc: "Recommendation to strengthen readiness before applying.", tenure: "—" },
  "Central government scheme": { desc: "Central government scheme-linked credit facility.", tenure: "Per scheme" },
};

export default function FinancingRoutes() {
  const pt = usePhrase();
  const [routes, setRoutes] = useState([]);
  useEffect(() => {
    (async () => {
      const b = await api.get("/businesses"); const biz = b.data[0]; if (!biz) return;
      const frs = await api.get("/funding-requirements");
      const fr = frs.data.find((f) => f.business_id === biz.id);
      if (fr) {
        const { data } = await api.get(`/funding-requirements/${fr.id}/routes`);
        setRoutes(data.routes || []);
      }
    })();
  }, []);

  return (
    <div className="space-y-6" data-testid="routes-page">
      <div>
        <h1 className="text-3xl font-bold text-slate-900 brand-heading">{pt("Financing Routes")}</h1>
        <p className="text-slate-600 mt-1 text-sm">{pt("Possible routes based on your readiness and requirement. Indicative only.")}</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {routes.map((r) => {
          const d = routeDetails[r] || {};
          return (
            <div key={r} className="p-6 rounded-lg border border-slate-200 bg-white card-hover" data-testid={`route-card-${r}`}>
              <div className="w-10 h-10 rounded-md bg-slate-900 grid place-items-center text-white mb-4"><Route className="w-5 h-5" /></div>
              <div className="font-semibold text-slate-900 brand-heading">{pt(r)}</div>
              <p className="text-sm text-slate-600 mt-2 leading-relaxed">{pt(d.desc || "Explore this route based on your profile.")}</p>
              <div className="mt-3 text-xs text-slate-500">{pt("Typical tenure:")} <span className="font-semibold text-slate-800">{pt(d.tenure || "Per lender policy")}</span></div>
              <div className="mt-4 text-[11px] text-amber-800 bg-amber-50 border border-amber-200 rounded-md p-2">{pt("Indicative match. Final eligibility, primary security, guarantee coverage & valuation are subject to lender policy.")}</div>
            </div>
          );
        })}
        {routes.length === 0 && <div className="text-sm text-slate-500">{pt("No routes yet — complete your Financial Passport.")}</div>}
      </div>
      <DisclaimerBanner compact />
    </div>
  );
}
